import React from "react";

const Home = () => {
  return (
    <div className="container">
      

      <div className="main">
        <div className="motto">
          <h3>
            We as a Bank provide a pathway between
            <br /> <span>You and Your Dream</span>.
          </h3>
        </div>
        <div className="logo">
          <img
            src="https://images.unsplash.com/photo-1501167786227-4cba60f6d58f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8YmFua3xlbnwwfHwwfHw%3D&auto=format&fit=crop&w=700&q=60"
            alt=""
          />
        </div>
      </div>

      <div className="footer">
        <h4>Created with &hearts; by &#169; Jatin Bhargava 2023 </h4>
      </div>
    </div>
  );
};

export default Home;
